import React, { useEffect, useRef } from 'react';

import { TWITTER_BEGIN_AUTH_URL } from 'services/TwitterService';


const TwitterConnectPage = () => {
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  }, [formRef]);

  return (
    <form
      ref={formRef}
      action={TWITTER_BEGIN_AUTH_URL}
      method="POST"
    />
  );
};

export default TwitterConnectPage;
